import * as types from '../actions/actionTypes';

const isActiveFund = fund => fund.active !== false;

const toFundOption = fund => ({ key: fund.fundId, value: fund.name });

const buildFundsByDeptState = funds => {
    const activeFunds = funds.filter(isActiveFund);

    return {
        loading: false,
        success: true,
        all: funds.map(toFundOption),
        allWithLimits: funds.map(f => ({ key: f.fundId, value: f })),
        activeAll: activeFunds.map(toFundOption),
        activeAllWithLimits: activeFunds.map(f => ({ key: f.fundId, value: f })),
        US: funds.filter(fund => fund.department === "US").map(toFundOption),
        IL: funds.filter(fund => fund.department === "IL").map(toFundOption),
        activeUS: activeFunds.filter(fund => fund.department === "US").map(toFundOption),
        activeIL: activeFunds.filter(fund => fund.department === "IL").map(toFundOption)
    };
};

const initialState = {
    funds: {
        loading: false,
        success: true,
        data: []
    },
    fundsByDept: {
        loading: false,
        success: true,
        all: [],
        allWithLimits: [],
        activeAll: [],
        activeAllWithLimits: [],
        US: [],
        IL: [],
        activeUS: [],
        activeIL: []
    },
    newFund: {
        loading: false,
        success: true
    }
}

export default (state = initialState, action) => {
    switch (action.type) {
        case types.START_GET_FUNDS:
            return Object.assign({}, state, { fundsByDept: { ...initialState.fundsByDept, loading: true } });
        case types.GET_FUNDS:
            return Object.assign({}, state, {
                fundsByDept: action.response.success ? buildFundsByDeptState(action.response.data) : { ...initialState.fundsByDept, loading: false, success: false }
            });

        case types.START_GET_FUNDS_VERBOSE:
            return Object.assign({}, state, { funds: { ...initialState.funds, loading: true } });
        case types.GET_FUNDS_VERBOSE:
            return Object.assign({}, state, { funds: action.response });

        case types.START_CREATE_FUND:
            return { ...state, newFund: { ...initialState.newFund, loading: true } };
        case types.CREATE_FUND:
            return { ...state, newFund: { ...action.response } };

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/FundsReducer.js